// TODO: Move/refactor these components into this "rich-content" space
import { AgileVideo } from "@/components/agile-video/agile-video";
import { BodyAssetComponent } from "@/templates/agile-hub/src/sections/components/body-asset";
import { RichTextComponent } from "@/templates/agile-hub/src/sections/components/body-text";
import { CallOutComponent } from "@/templates/agile-hub/src/sections/components/callout-component";
import { ProTipTextComponent } from "@/templates/agile-hub/src/sections/components/protip-text";
import { QuestionComponent } from "@/templates/agile-hub/src/sections/components/question-component";
import { TwitterTextComponent } from "@/templates/agile-hub/src/sections/components/twitter-text";
import { ProductCTA } from "@/templates/agile-hub/src/sections/product-cta";
import {
    ContentComponent,
    isQuestionComponent,
    isProTipText,
    isEmbedComponent,
    isCallToAction,
    isCallOutComponent,
    isAssetComponent,
    isTextComponent,
    isTwitterComponent
} from "@/templates/agile-hub/types";

export type RichContentProps = ContentComponent;

export const RichContent = (data: RichContentProps): JSX.Element | null => {
    if (isTextComponent(data)) {
        return <RichTextComponent {...data} />;
    } else if (isEmbedComponent(data)) {
        return (
            <AgileVideo
                embedLink={data.embedded || ""}
                title={data.embeddedVideoAssetName || ""}
                thumbnail={data.embedAssetOverlay}
            />
        );
    } else if (isProTipText(data)) {
        return <ProTipTextComponent {...data} />;
    } else if (isTwitterComponent(data)) {
        return <TwitterTextComponent {...data} />;
    } else if (isAssetComponent(data)) {
        return <BodyAssetComponent {...data} />;
    } else if (isCallToAction(data)) {
        return <ProductCTA name={""} {...data} />;
    } else if (isCallOutComponent(data)) {
        return <CallOutComponent {...data} />;
    } else if (isQuestionComponent(data)) {
        return <QuestionComponent {...data} />;
    }

    return null;
};
